export function formatDate(dateString) {
  if (!dateString) return "";
  const date = new Date(dateString);

  if (isNaN(date)) {
    return "Invalid Date";
  }

  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
  ];

  const month = months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12 || 12; // Convert to 12-hour format

  return `${month} ${day}, ${year} at ${hours}:${minutes} ${ampm}`;
}
